document.addEventListener("DOMContentLoaded", function () {
  const promoBannerFixed = document.querySelector(".promo-fixed");
  const promoBanner = document.querySelector(".promo__banner");
  const promoClose = document.querySelector("#close-promo-banner");
  const stickyEl = document.querySelector(".js-site-navigation");
  const fixedMobNav = document.querySelector(".site-header__mobile-tools");

  if (!promoBanner) return;

  // Function to check if localStorage has expired
  const isPopupExpired = function () {
    const savedTime = localStorage.getItem("popupTimestamp");
    if (!savedTime) return true;

    const currentTime = Date.now();
    const oneDay = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

    return currentTime - savedTime > oneDay;
  };

  // Check localStorage and show banner if needed
  if (!localStorage.getItem("popupClosed") || isPopupExpired()) {
    promoBanner.classList.add("show");  // Add the 'show' class to display the banner
    localStorage.setItem("popupTimestamp", Date.now());
  } else {
    promoBanner.remove();  // Remove the banner from the DOM if it shouldn't be shown
    return;  // Stop further execution if the banner shouldn't be shown
  }

  // Close button event listener
  if (promoClose) {
    promoClose.addEventListener("click", function () {
      if (stickyEl) stickyEl.style.top = "";
      if (fixedMobNav) fixedMobNav.style.top = "";

      promoBanner.classList.remove("show"); // Remove the 'show' class to hide the banner
      localStorage.setItem("popupClosed", "true");
      localStorage.setItem("popupTimestamp", Date.now());

      // Optionally, remove from the DOM after the transition
      setTimeout(() => {
        promoBanner.remove();
      }, 300); // Match the duration of the transition
    });
  }

  // Function to handle the fixed class
  const toggleBannerVisibility = function () {
    if (!promoBannerFixed) return;

    if (window.scrollY > 0) {
      promoBannerFixed.classList.add("fixed");
    } else {
      promoBannerFixed.classList.remove("fixed");
    }
  };

  // Run on scroll
  window.addEventListener("scroll", toggleBannerVisibility);
  toggleBannerVisibility();
});
